import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { defaultBillingDayOfWeek, repeatableManualBillingDayOfMonth } from '~/constants';
import { BillingTriggerType } from '~/types/api.model';
import { BillingDayOfMonthModel } from '../BillingDayOfMonth';
import { getValidOngoingBilling } from '../service/newOngoingBilling';
import { RecurrencePeriodTypes } from './model';
import * as selectors from './selectors';
export function makeOnApprovalBilling() {
    return {
        trigger: BillingTriggerType.OnApproval
    };
}
export function makeOneTimeManualBilling() {
    return {
        trigger: BillingTriggerType.OneTimeManual
    };
}
export function makeRepeatableManualBilling(period) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { maxCharges } = options;
    return {
        trigger: BillingTriggerType.RepeatableManual,
        recurrencePeriod: period,
        isBilledUpfront: true,
        billingDayOfMonth: period === RecurrencePeriodTypes.Monthly ? BillingDayOfMonthModel.make(repeatableManualBillingDayOfMonth) : null,
        billingDayOfWeek: selectors.periodRequiresBillingDayOfWeek(period) ? defaultBillingDayOfWeek : null,
        billingDayOfYear: period === RecurrencePeriodTypes.Yearly ? null : null,
        maxCharges: maxCharges != null ? maxCharges : makeMaxCharges(false)
    };
}
export function makeOngoingBilling(period) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { billingDayOfMonth, billingDayOfWeek, billingDayOfYear, isPaused = false, isProrated = false, isBilledUpfront = false, billUpfrontState = makeBillUpfrontState(false), maxCharges, isAwaitingApproval, startBillingAt } = options;
    return _object_spread({
        trigger: BillingTriggerType.Ongoing,
        recurrencePeriod: period,
        billingDayOfMonth: period === RecurrencePeriodTypes.Monthly ? billingDayOfMonth || BillingDayOfMonthModel.make() : null,
        billingDayOfWeek: selectors.periodRequiresBillingDayOfWeek(period) ? billingDayOfWeek || defaultBillingDayOfWeek : null,
        billingDayOfYear: period === RecurrencePeriodTypes.Yearly ? billingDayOfYear || null : null,
        maxCharges: maxCharges != null ? maxCharges : makeMaxCharges(false)
    }, isAwaitingApproval ? getValidOngoingBilling({
        isPaused,
        isProrated,
        isBilledUpfront,
        billUpfrontState,
        startBillingAt: startBillingAt != null
    }) : {
        isPaused,
        isProrated,
        isBilledUpfront,
        billUpfrontState
    });
}
export function makeOneTimeInStagesBilling(oneTimeInStages) {
    return {
        trigger: BillingTriggerType.OneTimeInStages,
        oneTimeInStages
    };
}
export function makeOnDemandBilling(preapprovalPeriod) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { maxCharges } = options;
    return {
        trigger: BillingTriggerType.OnDemand,
        preapprovalPeriod,
        maxCharges: maxCharges != null ? maxCharges : makeMaxCharges(false)
    };
}
export function makeMaxCharges(enabled, limit, chargesLeft) {
    return {
        enabled,
        limit: enabled ? limit || null : null,
        chargesLeft: enabled ? (chargesLeft != null ? chargesLeft : limit) || null : null
    };
}
export function makeBillUpfrontState(skipBillingOnAcceptance) {
    return {
        skipBillingOnAcceptance
    };
}
